import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"33rem","max-width":"80vw"},
  class: "relative edit-body h-full"
}
const _hoisted_2 = { class: "gap-x-3 px-6 pb-6 pt-4 flex justify-center flex-col gap-y-4" }
const _hoisted_3 = { class: "mt-4 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "dialog-airport",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.show = $event)),
    title: _ctx.modalTitle,
    persistent: "",
    customBody: "py-3",
    onReset: _ctx.onReset
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_DataWrapper, { label: "Platform" }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                modelValue: _ctx.form.platform,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.platform = $event)),
                selectedItem: _ctx.form.platform,
                class: "w-full mt-1.5",
                placeholder: _ctx.platformPlaceholder,
                options: _ctx.platformOptions,
                isCustomWidth: "",
                customChips: "rounded-full px-2 text-black-lp-300 bg-gray-lp-200"
              }, null, 8, ["modelValue", "selectedItem", "placeholder", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: _ctx.storeNameLabel,
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.form.appName,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.appName = $event)),
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.error.appName = ''))
                ],
                placeholder: _ctx.storeNamePlaceholder,
                error: !!_ctx.error.appName,
                isErrorIconInput: false,
                isErrorIconCaption: false,
                errorCaption: _ctx.error.appName
              }, null, 8, ["modelValue", "placeholder", "error", "errorCaption"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: "Domain",
            class: "w-full"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                modelValue: _ctx.form.domain,
                "onUpdate:modelValue": [
                  _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.domain = $event)),
                  _cache[5] || (_cache[5] = ($event: any) => (_ctx.error.domain = ''))
                ],
                placeholder: _ctx.domainPlaceholder,
                error: !!_ctx.error.domain,
                isErrorIconInput: false,
                isErrorIconCaption: false,
                errorCaption: _ctx.error.domain
              }, null, 8, ["modelValue", "placeholder", "error", "errorCaption"])
            ]),
            _: 1
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_LpButton, {
              textColor: "white",
              title: _ctx.generateTokenLabel,
              fontWeight: "semibold",
              color: "red-lp-100",
              isWidthFull: "",
              customClass: "py-2 px-8",
              onClick: _ctx.onProcess,
              disabled: _ctx.disabled
            }, null, 8, ["title", "onClick", "disabled"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title", "onReset"]))
}